import {intersection} from 'lodash';
import {selector} from 'recoil';
import {search} from '../util/searchEngine';
import {searchState} from './searchState';
import {selectedTagsState} from './selectedTagsState';

const searchDescrizione = (item, searchString) => {
	return item.Descrizione.search(new RegExp(searchString.replace(/[()]/g, '\\$&'), 'i')) > -1;
}

const filterBranche = (sezione, selectedTag) => {
	return sezione.ElencoBranche.filter((branca) => {
		if (branca.Tag && branca.Tag.length && intersection(branca.Tag, selectedTag).length > 0) {
			return branca;
		}

		if (filterSottobranche(branca, selectedTag).length > 0) {
			return branca;
		}
	});
};

const filterSottobranche = (branca, selectedTag) => {
 	return branca.ElencoSottobranche?.filter(
		(sottobranca) => sottobranca.Tag && sottobranca.Tag.length && intersection(sottobranca.Tag, selectedTag).length > 0
	);
};

const filterTariffe = (branca, searchString) => branca.ElencoTariffe.filter(tariffa => searchDescrizione(tariffa, searchString));

const filterTariffeSottobranche = (branca, searchString) => {
	let hasSearchedBranca = searchString && branca.Descrizione.toLowerCase().includes(searchString.toLowerCase());

	return branca.ElencoSottobranche?.map(item => {
		let hasSearchedSottobranca = item.Descrizione.toLowerCase().includes(searchString.toLowerCase());

		return {
			...item,

			ElencoSottobranche: (hasSearchedBranca || hasSearchedSottobranca) ? item.ElencoSottobranche : filterTariffeSottobranche(item, searchString),

			ElencoTariffe: (hasSearchedBranca || hasSearchedSottobranca) ? item.ElencoTariffe : filterTariffe(item, searchString),
		};
	}).filter((b) => b.ElencoTariffe?.length > 0 || b.ElencoSottobranche?.length > 0);
};

export const tariffarioState = selector({
	key: 'tariffarioState', get: ({get}) => {
		const searchString = get(searchState);
		const selectedTag = get(selectedTagsState);
		let result = search.data;

		if (searchString && searchString !== '') {
			result = search.search(searchString);

			result = result.map(sezione => {
				const hasSearchedSezione = sezione.Descrizione.toLowerCase().includes(searchString.toLowerCase());
				const searchedBranca = sezione.ElencoBranche?.filter(branca => searchDescrizione(branca, searchString));

				return {
					...sezione,

					ElencoTariffe: hasSearchedSezione ? sezione.ElencoTariffe : filterTariffe(sezione, searchString),

					ElencoBranche: sezione.ElencoBranche.map((branca) => ({
						...branca,
						ElencoTariffe: (hasSearchedSezione || (searchedBranca.length > 0 && searchedBranca[0].Descrizione === branca.Descrizione)) ? branca.ElencoTariffe : filterTariffe(branca, searchString),
						ElencoSottobranche: hasSearchedSezione ? branca.ElencoSottobranche : filterTariffeSottobranche(branca, searchString),
					})).filter(b => b.ElencoTariffe?.length > 0 || b.ElencoSottobranche?.length > 0),
				};
			}).filter(t => t.ElencoTariffe?.length > 0 || t.ElencoBranche?.length > 0 || t.ElencoSottobranche?.length > 0);
		}

		if (selectedTag.length) {
			result = result.map(sezione => {
				const filteredBranche = filterBranche(sezione, selectedTag);

				const hasTagInSezione = intersection(sezione.Tag, selectedTag).length > 0;
				const hasTagInBranca = filteredBranche.length > 0;

				console.log('filteredBranche', filteredBranche);
				console.log('hasTagInSezione', hasTagInSezione);
				console.log('hasTagInBranca', hasTagInBranca);
				console.log(
				);
				console.log('------');

				return {
					...sezione,

					ElencoTariffe: hasTagInSezione ? sezione.ElencoTariffe : [],

					ElencoBranche: filteredBranche.map((branca) => ({
						... hasTagInBranca ? branca : null,
						ElencoTariffe: hasTagInBranca ? branca.ElencoTariffe : [],
						ElencoSottobranche: filterSottobranche(branca, selectedTag),
					})).filter(b => b.ElencoTariffe?.length > 0 || b.ElencoSottobranche?.length > 0),
				};
			}).filter(t => t.ElencoTariffe?.length > 0 || t.ElencoBranche?.length > 0 || t.ElencoSottobranche?.length > 0);

			console.log('result', result);
		}

		return result;
	}
});
